module.exports = __webpack_public_path__ + "img/faq.fb982ef4.jpg";